/* PureEthical v29 (Fase 0) - pesquisa com sugestoes enquanto se escreve.

   Antes: o pe-ui.js tinha o pedido a /search/suggest.json, mas o elemento onde
   os resultados deviam aparecer (#searchPredict) nao existia, por isso nunca se
   via nada. Este ficheiro usa o painel de pesquisa que ja existe (#searchPanel)
   e mostra, com dados reais da loja (API de sugestoes da Shopify):
     - produtos (foto, marca, nome, preco; preco riscado so se existir na loja)
     - marcas (colecoes cujo nome e uma marca vendida: window.PE_VENDORS)
     - categorias (as restantes colecoes)
   Nada e inventado: sem resultados, diz-o e sugere as Novidades.
   Usa o prefixo da lingua atual (/fr/, /en/...) para os nomes virem traduzidos. */
(function () {
  'use strict';

  function init() {
    var panel = document.getElementById('searchPanel');
    var input = document.getElementById('searchInput');
    var box = document.getElementById('peSearchSuggest');
    if (!panel || !input || !box || box.getAttribute('data-pe-on')) return;
    box.setAttribute('data-pe-on', '1');

    var root = box.getAttribute('data-root') || '/';
    if (root.charAt(root.length - 1) !== '/') root += '/';
    var T = function (k, f) { return box.getAttribute('data-t-' + k) || f; };
    var lang = (document.documentElement.getAttribute('lang') || 'pt-PT');
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    var fmt;
    try { fmt = new Intl.NumberFormat(lang, { style: 'currency', currency: cur }); } catch (e) { fmt = null; }
    /* v38 velocidade: a lista de marcas (window.PE_VENDORS) chega quando a pesquisa abre (theme.liquid,
       sections/pe-search-data.liquid); o mapa e refeito quando a lista muda */
    var vendors = {}, vendorsSrc = null;
    function vmap() {
      var src = window.PE_VENDORS || null;
      if (src !== vendorsSrc) { vendorsSrc = src; vendors = {}; (src || []).forEach(function (v) { vendors[norm(v)] = 1; }); }
      return vendors;
    }

    var timer = null, seq = 0, ctrl = null, lastQ = '';

    function norm(s) {
      return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]+/g, ' ').trim();
    }
    function esc(s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }
    /* destaca as palavras pesquisadas (sem acentos, sem distinguir maiusculas) */
    function hl(text, q) {
      var safe = esc(text);
      var words = norm(q).split(' ').filter(function (w) { return w.length > 1; });
      if (!words.length) return safe;
      var plain = norm(text);
      var marks = [];
      words.forEach(function (w) {
        var i = plain.indexOf(w);
        if (i > -1) marks.push([i, i + w.length]);
      });
      if (!marks.length) return safe;
      /* a normalizacao mantem o comprimento quando so tira acentos; se nao, nao destaca */
      if (plain.length !== String(text).length) return safe;
      marks.sort(function (a, b) { return a[0] - b[0]; });
      var out = '', pos = 0, raw = String(text);
      marks.forEach(function (m) {
        if (m[0] < pos) return;
        out += esc(raw.slice(pos, m[0])) + '<mark>' + esc(raw.slice(m[0], m[1])) + '</mark>';
        pos = m[1];
      });
      return out + esc(raw.slice(pos));
    }
    function money(v) {
      var n = parseFloat(v);
      if (isNaN(n)) return '';
      return fmt ? fmt.format(n) : n.toFixed(2).replace('.', ',') + ' €';
    }
    function img(u, w) {
      if (!u) return '';
      return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
    }
    function clear() {
      box.innerHTML = '';
      panel.classList.remove('pe-sg-on');
    }
    function searchUrl(q) { return root + 'search?type=product&q=' + encodeURIComponent(q); }

    function render(q, data) {
      var r = (data && data.resources && data.resources.results) || {};
      var prods = (r.products || []).filter(function (p) { return (p.featured_image && p.featured_image.url) || p.image; }).slice(0, 6); /* v30: produtos sem foto nao aparecem nas sugestoes */
      var cols = r.collections || [];
      var brands = [], cats = [], seen = {};
      function path(u) { return String(u || '').split('?')[0]; }
      /* categorias da loja (nome traduzido): cada palavra pesquisada tem de comecar uma palavra do nome */
      var qw = norm(q).split(' ').filter(Boolean);
      (window.PE_CATS || []).map(function (c) {
        var tw = norm(c.t).split(' ');
        var ok = qw.every(function (w) { return tw.some(function (x) { return x.indexOf(w) === 0 || (w.length > 4 && w.indexOf(x) === 0 && x.length > 3); }); });
        return ok ? { title: c.t, url: c.u, n: c.n, score: (norm(c.t) === norm(q) ? 0 : 1) * 1000 + tw.length * 10 } : null;
      }).filter(Boolean).sort(function (a, b) { return a.score - b.score; }).forEach(function (c) {
        if (cats.length < 5 && !seen[path(c.url)]) { seen[path(c.url)] = 1; cats.push(c); }
      });
      cols.forEach(function (c) {
        if (!c || !c.url || seen[path(c.url)]) return;
        /* v30 F0.5: a colecao "Mais vendidos" nao aparece nas sugestoes (a loja ainda nao tem vendas que a sustentem) */
        if (/\/collections\/best-sellers$/.test(path(c.url))) return;
        seen[path(c.url)] = 1;
        if (vmap()[norm(c.title)]) { if (brands.length < 5) brands.push(c); }
        else if (cats.length < 5) cats.push(c);
      });
      if (!prods.length && !brands.length && !cats.length) {
        box.innerHTML = '<p class="pe-sg-none">' + esc(T('none', 'Sem resultados para')) + ' “' + esc(q) + '”. ' +
          '<a href="' + esc(box.getAttribute('data-new-url') || (root + 'collections/new-arrivals')) + '">' + esc(T('none2', '')) + '</a></p>';
        return;
      }
      var h = '<div class="pe-sg-grid">';
      h += '<div class="pe-sg-col">';
      if (prods.length) {
        h += '<p class="pe-sg-h">' + esc(T('products', 'Produtos')) + '</p><div class="pe-sg-prods">';
        prods.forEach(function (p) {
          var price = money(p.price);
          /* v30 F0.5: so o preco atual - o compare_at nao e mostrado como preco anterior */
          var priceHtml = esc(price);
          var im = (p.featured_image && p.featured_image.url) || p.image || '';
          h += '<a class="pe-sg-p" href="' + esc(p.url) + '">' +
            '<span class="pe-sg-img">' + (im ? '<img src="' + esc(img(im, 160)) + '" alt="" width="80" height="120">' : '') + '</span>' +
            '<span class="pe-sg-txt">' +
              (p.vendor ? '<span class="pe-sg-v" translate="no">' + esc(p.vendor) + '</span>' : '') +
              '<span class="pe-sg-t">' + hl(p.title, q) + '</span>' +
              '<span class="pe-sg-pr">' + priceHtml + '</span>' +
            '</span></a>';
        });
        h += '</div>';
      }
      h += '<a class="pe-sg-all" href="' + esc(searchUrl(q)) + '">' + esc(T('all', 'Ver todos os resultados')) + ' →</a>';
      h += '</div><div class="pe-sg-col">';
      if (brands.length) {
        h += '<p class="pe-sg-h">' + esc(T('brands', 'Marcas')) + '</p><div class="pe-sg-links">';
        brands.forEach(function (c) { h += '<a class="pe-sg-l" href="' + esc(c.url) + '" translate="no"><span>' + hl(c.title, q) + '</span></a>'; });
        h += '</div>';
      }
      if (cats.length) {
        h += '<p class="pe-sg-h">' + esc(T('cats', 'Categorias')) + '</p><div class="pe-sg-links">';
        cats.forEach(function (c) { h += '<a class="pe-sg-l" href="' + esc(c.url) + '"><span>' + hl(c.title, q) + '</span>' + (c.n ? '<small>' + c.n + '</small>' : '') + '</a>'; });
        h += '</div>';
      }
      h += '</div></div>';
      box.innerHTML = h;
    }

    function run() {
      var q = input.value.trim();
      if (q.length < 2) { lastQ = ''; clear(); return; }
      if (q === lastQ) return;
      lastQ = q;
      panel.classList.add('pe-sg-on');
      if (!box.firstChild) box.innerHTML = '<p class="pe-sg-status">' + esc(T('loading', '…')) + '</p>';
      var my = ++seq;
      if (ctrl && ctrl.abort) { try { ctrl.abort(); } catch (e) {} }
      ctrl = window.AbortController ? new AbortController() : null;
      var url = root + 'search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product,collection&resources[limit]=10&resources[limit_scope]=each' +
        '&resources[options][unavailable_products]=hide' +
        '&resources[options][fields]=title,product_type,vendor,variants.title,tag';
      fetch(url, ctrl ? { signal: ctrl.signal, credentials: 'same-origin' } : { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
        .then(function (d) { if (my === seq) render(q, d); })
        .catch(function (e) {
          if (e && e.name === 'AbortError') return;
          if (my === seq) {
            /* sem sugestoes: a pesquisa normal (Enter) continua a funcionar */
            box.innerHTML = '<a class="pe-sg-all" href="' + esc(searchUrl(q)) + '">' + esc(T('all', 'Ver todos os resultados')) + ' →</a>';
          }
        });
    }

    input.addEventListener('input', function () {
      clearTimeout(timer);
      timer = setTimeout(run, 180);
    });
    /* teclado: seta para baixo entra nos resultados; setas navegam; Escape volta ao campo */
    input.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') {
        var first = box.querySelector('a');
        if (first) { e.preventDefault(); first.focus(); }
      }
    });
    box.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp' && e.key !== 'Escape') return;
      var links = Array.prototype.slice.call(box.querySelectorAll('a'));
      var i = links.indexOf(document.activeElement);
      if (e.key === 'Escape') { e.preventDefault(); input.focus(); return; }
      e.preventDefault();
      if (e.key === 'ArrowDown' && i < links.length - 1) links[i + 1].focus();
      else if (e.key === 'ArrowUp') { if (i > 0) links[i - 1].focus(); else input.focus(); }
    });
    /* ao fechar/limpar o painel, limpa as sugestoes */
    input.addEventListener('search', function () { if (!input.value) { lastQ = ''; clear(); } });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
